export default __webpack_public_path__ + "static/media/frame_th_pc@2x.58f4207f.png";